import { GOOGLE_FONTS_RANGES } from "@excalidraw/common";
import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

export const NunitoBoldFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: "https://fonts.gstatic.com/s/nunito/v31/XRXV3I6Li01BKofIOOaBTMnFcQIG.woff2",
    descriptors: { 
      unicodeRange: GOOGLE_FONTS_RANGES.CYRILIC_EXT,
      weight: "700",
      style: "normal"
    },
  },
  {
    uri: "https://fonts.gstatic.com/s/nunito/v31/XRXV3I6Li01BKofIMeaBTMnFcQIG.woff2",
    descriptors: { 
      unicodeRange: GOOGLE_FONTS_RANGES.CYRILIC,
      weight: "700",
      style: "normal"
    },
  },
  {
    uri: "https://fonts.gstatic.com/s/nunito/v31/XRXV3I6Li01BKofIOuaBTMnFcQIG.woff2",
    descriptors: { 
      unicodeRange: GOOGLE_FONTS_RANGES.VIETNAMESE,
      weight: "700",
      style: "normal"
    },
  },
  {
    uri: "https://fonts.gstatic.com/s/nunito/v31/XRXV3I6Li01BKofIO-aBTMnFcQIG.woff2",
    descriptors: { 
      unicodeRange: GOOGLE_FONTS_RANGES.LATIN_EXT,
      weight: "700",
      style: "normal"
    },
  },
  {
    uri: "https://fonts.gstatic.com/s/nunito/v31/XRXV3I6Li01BKofINeaBTMnFcQ.woff2",
    descriptors: { 
      unicodeRange: GOOGLE_FONTS_RANGES.LATIN,
      weight: "700",
      style: "normal"
    },
  },
]; 